'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'bolt';
var width = 448;
var height = 512;
var aliases = [9889,"zap"];
var unicode = 'f0e7';
var svgPathData = ['M100.4 248.7l54.1 7.2 53.3 7.1-13 52.1-19.3 77.4L347.6 263.3l-54.1-7.2L240.3 249l13-52.1 19.3-77.4L100.4 248.7z', 'M311.6 161.7l22-87.8L352 0 291.1 45.7 32 240l0 48 68.2 9.1 47.9 6.4-11.7 46.9-22 87.8L96 512l60.9-45.7L416 272l0-48-68.2-9.1-47.9-6.4 11.7-46.9zm36 101.7L175.4 392.5l19.3-77.4 13-52.1-53.3-7.1-54.1-7.2L272.6 119.5l-19.3 77.4-13 52.1 53.3 7.1 54.1 7.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBolt = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;